var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"org-target-list"},_vm._l((_vm.info.items),function(item){return _c('WishListItem',{key:item.email,attrs:{"item":item,"onDeleteOne":_vm.onDeleteOne,"onSelect":_vm.onSelect,"onDelete":_vm.onDelete}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }